import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import OtpModal from "../../groups_/modal/OtpModal";
import { Descriptions, Spin, Table } from "antd";
import { cashConverter } from "../../../../utils";
import svg65 from "../../../../assets/svg/svg65.svg";
import { save } from "../../../../features/save/saveSlice";
import { fetchGrpTotals } from "../../../../features/fetch/fetchSlice";
import { clearObj } from "../../../../features/obj/objSlice";

export default function Step3({ handleNext, handleBack, form }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { activeObj, memberObj, sourceName, categoryObj } = useSelector(
    (state) => state.obj
  );
  const { saving } = useSelector((state) => state.save);

  const { grpTotals } = useSelector((state) => state.fetch);
  const { singlePaymentObj } = useSelector((state) => state.obj);
  const [openOtp, setopenOtp] = useState(false);
  async function handleCancelOtp() {
    await setopenOtp(false);
  }
  const [resMess, setResMess] = useState();

  async function handleCancelAll() {
    await setopenOtp(false);
    await navigate("/groups");
    await setResMess("");
  }

  async function handleOpenOtp() {
    await setopenOtp(true);
  }
  const handleFetchData = () => {};
  const onFinish = async (data) => {
    const memberId =
      memberObj?.length > 0 ? memberObj?.map((item) => item?.pgdId) : [];
    const res = await dispatch(
      save({
        ...activeObj,
        pgdId: memberId,
        url: `api/v1/payments/disburse-payment-group/${activeObj?.pgId}`,
      })
    );

    if (res?.payload?.success) {
      await setResMess(res?.payload?.data?.result);
      if (res?.payload?.data?.result?.hasReviewers) {
        await toast.success(res?.payload?.messages?.message);
        await navigate("/group-payment");
        await dispatch(clearObj());
      } else {
        await toast.success(res?.payload?.messages?.message);
        await handleOpenOtp();
      }
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handlePrev = async () => {
    await handleBack();
  };

  async function fetchPaymentsTotal() {
    await dispatch(
      fetchGrpTotals({
        url: `api/v1/payments/fetch-payment-group-total/${activeObj?.pgId}`,
        pgdId: memberObj?.map((item) => item?.pgdId),
      })
    );
  } 
  console.log("memberObj",memberObj)
  const items = [
    {
      key: "1",
      label: "Payment Source",
      children: sourceName,
    },

    {
      key: "5",
      label: "Category",
      children: categoryObj?.categoryName,
    },
    {
      key: "6",
      label: "Sub-Category",
      children: categoryObj?.subCategoryName,
    },
    {
      key: "2",
      label: "Reason",
      children: activeObj?.pgReason,
    },

    {
      key: "4",
      label: "Amount",
      children: <div>{cashConverter(grpTotals?.sumTotalAmount)}</div>,
    },

    {
      key: "5",
      label: "Commission Amount",
      children: <div>{cashConverter(grpTotals?.sumCommissionAmount)}</div>,
    },

    {
      key: "6",
      label: "Transaction Amount",
      children: <div>{cashConverter(grpTotals?.sumTransactionAmount)}</div>,
    },
  ];

  const columns = [
    {
      title: "First Name",
      dataIndex: "pgdFirstName",
    },
    {
      title: "Last Name",
      dataIndex: "pgdLastName",
    },
    {
      title: "ID No.",
      dataIndex: "pgdNationalId",
    },
    {
      title: "Receiver Mobile No",
      dataIndex: "pgdReceiverMobileNo",
    },

    {
      title: "Account Number",
      dataIndex: "pgdBeneficiaryAccount",
    },
    {
      title: "Bank Name",
      dataIndex: "bnkName",
    },
    {
      title: "Amount",
      dataIndex: "pgdTrxAmount",
    },
     {
      title: "Commission Amount",
      render:(item)=>{
        return(
          <div>{cashConverter(item)}</div>
        )
      },
      dataIndex: "pgdComAmount", 
    },
    

    {
      title: "Payment Mode",
      dataIndex: "pgdPaymentMode",
    },
  ];

  useEffect(() => {
    fetchPaymentsTotal();
  }, []);
  return (
    <>
      {" "}
      <div className="lg:px-10 px-3">
        <p className="text-[15px] text-[#000] font-[600] mb-8 font-dmSans">
          Would you like to make the following transfer of{" "}
          {cashConverter(grpTotals?.sumTotalAmount)} ?
        </p>

        <div className="mt-[1.25rem] w-full">
          <Descriptions
            column={{
              xs: 1,
              sm: 1,
              md: 2,
              lg: 2,
              xl: 2,
              xxl: 2,
            }}
            colon={false}
            title="Group Payment Information"
            items={items}
          />
        </div>
        <Table
          scroll={{
            x: "auto",
          }}
          pagination={{
            defaultPageSize: 7,
            hideOnSinglePage: true,
            pageSizeOptions: [10, 20, 50, 100],
          }}
          rowKey={(record) => record?.pyId}
          className="mt-[1.5rem] !w-full"
          columns={columns}
          dataSource={memberObj}
        />
      </div>
      <div className="bg-[rgba(31,45,61,0.03)] mt-10">
        <div className="pt-[1.44rem] pb-[2.44rem] w-full flex justify-between items-center lg:px-10 px-3">
          <div className="w-[150px] ">
            <button
              disabled={saving}
              onClick={handlePrev}
              type="button"
              className="cstm-btn flex items-center gap-x-2"
            >
              <img src={svg65} alt="svg65" /> Previous
            </button>
          </div>

          <div className="w-[110px] ">
            <button
              onClick={onFinish}
              disabled={saving}
              type="button"
              className={`flex cstm-btn-2 `}
            >
              {saving ? <Spin /> : "Done"}
            </button>
          </div>
        </div>
      </div>
      <OtpModal
        handleFetchData={handleFetchData}
        open={openOtp}
        handleCancel={handleCancelOtp}
        handleCancelAll={handleCancelAll}
        resMess={resMess}
      />
    </>
  );
}
